'use client';

import { c as _c } from "react/compiler-runtime";
import { Range as SliderRangePrimitive, Root as SliderRootPrimitive, Thumb as SliderThumbPrimitive, Track as SliderTrackPrimitive } from '@radix-ui/react-slider';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { cn } from '@/lib/utils';
type SliderProperties = ComponentPropsWithoutRef<typeof SliderRootPrimitive> & {
  ref?: Ref<ComponentRef<typeof SliderRootPrimitive>> | undefined;
};
function Slider(t0) {
  const $ = _c(12);
  let className;
  let properties;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = properties;
    $[3] = ref;
  } else {
    className = $[1];
    properties = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex w-full touch-none select-none items-center", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SliderTrackPrimitive className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary"><SliderRangePrimitive className="absolute h-full bg-primary" /></SliderTrackPrimitive>;
    t3 = <SliderThumbPrimitive className="block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== properties || $[9] !== ref || $[10] !== t1) {
    t4 = <SliderRootPrimitive ref={ref} className={t1} {...properties}>{t2}{t3}</SliderRootPrimitive>;
    $[8] = properties;
    $[9] = ref;
    $[10] = t1;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
Slider.displayName = SliderRootPrimitive.displayName ?? 'Slider';
export { Slider };